import { useMemo } from "react";

import { LeadItem } from "../../../../queries/useGetDealerLeads";
import { useOrdersDateParam } from "./OrdersDateSelect";
import { getMinimumDate } from "./getMinimumDate";

interface LeadsDatePredicateHook {
  (): (item: LeadItem) => boolean;
}

export const useLeadsDatePredicate: LeadsDatePredicateHook = () => {
  const [date] = useOrdersDateParam();
  const predicate = useMemo(
    () => (item: LeadItem) => {
      const minDate = getMinimumDate(date);
      return new Date(item.createdTimestamp.date) >= minDate;
    },
    [date]
  );
  return predicate;
};
